document.addEventListener('alpine:init', () => {
    /**
     * click link in child element
     * used for card currently
     */
    window.Alpine.magic('clickChildLink', (el) => () => {
        let link = el.getElementsByTagName('a')[0];
        link.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        link.click();
    });

});
